import React, { useEffect } from 'react'

import LinedDecorTitleGreen from '../LinedDecorTitleGreen/LinedDecorTitleGreen'
import JobsList from '../JobsList/JobsList'
import { useGetPopularJobsQuery } from './api/popularJobsApi'
import { LgbtToast } from '../LgbtToast/LgbtToast'
import styles from './PopularJobsSecondaryColor.module.scss'


function PopularJobsSecondaryColor(props) {

    const { data, isError, error, isLoading, isFetching } = useGetPopularJobsQuery()

    useEffect(() => {
        if (isError || error) {
            LgbtToast({ message: error.status, type: 'error' })
        }
    }, [error, isError])

    if (isError) {
        return null;
    }

    return (
        <div className={styles.popularJobsSec}>
            <div className={styles.jobBgWrapper}>
                <div className="container">
                    <LinedDecorTitleGreen className={styles.propTitle}>{props.title}</LinedDecorTitleGreen>
                </div>
                <div className="container">
                    <JobsList className={styles.secJobListing} jobs={data} isLoading={isLoading} isFetching={isFetching} passiveLoadMore={true} />
                </div>
            </div>
        </div>
    )
}

export default PopularJobsSecondaryColor